import React, {Component} from 'react';
import {connect} from 'react-redux';
import style from '../css/totalBets.css';
// helpers
import {getFormattedCurrency, getText} from '../../../../helpers/localization';

const mapStateToProps = (state, ownProps) => {
    return {openBetsList: state.vpp.openBetsList};
};

class TotalBets extends Component {
    constructor(props) {
        super(props);
        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            openBetsList: storeData.vpp.openBetsList
        };
    }

    componentWillReceiveProps(nextProps) {
        let store = this.props.store;
        let storeData = store.getState();

        this.setState({openBetsList: storeData.vpp.openBetsList});
    }

    render() {
        let totalBetsValue = 0;
        this.state.openBetsList.map(openBet => {
            return totalBetsValue += openBet.stake;
        });
        totalBetsValue = totalBetsValue / 100;

        return (
            <div id={'totalBetsText'} className={style.totalBetContainer}>
                <div className={style.valuesContainer}>
                    <div className={style.totalBetText}>{getText('TOTAL_BETS', this.props.store)}</div>
                    <div className={style.totalBetValue}>{getFormattedCurrency(this.props.store, totalBetsValue)}</div>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps)(TotalBets);



// WEBPACK FOOTER //
// ./src/ui-modules/simplified/mobile/components/totalBets.js